import { KycInfoParams, KycType } from '@views/health/kyc/types';

import { client } from '../client';
import { PresignedURLResponse } from '../common/types';

import { healthEndPoints } from './endpoints';
import { InitiateEKYCResponse, KycDocument, KycInfoResponse } from './types';

export const healthKycAPIs = {
  initiateEKYC: (policyId: string): Promise<InitiateEKYCResponse> =>
    client.post(healthEndPoints.initiateEKYC(policyId)),
  completeKycUsingPhysicalDoc: (
    policyId: string,
    documents: KycDocument[]
  ): Promise<{ success: boolean }> =>
    client.post(healthEndPoints.completeKycUsingPhysicalDoc(policyId), {
      documents
    }),
  getKycInfo: (
    policyId: string,
    params: KycInfoParams,
    kyc_type: KycType
  ): Promise<KycInfoResponse> =>
    client.post(healthEndPoints.getKycInfo(policyId, kyc_type), {
      ...params
    }),
  getPreSignedURL: (
    policyID: string,
    fileNames: string[]
  ): Promise<PresignedURLResponse> =>
    client.post(
      healthEndPoints.getPreSignedURL(policyID),
      { files: fileNames },
      {
        params: {
          path: 'kyc'
        }
      }
    )
};
